import { MobileUserRole } from "@ac-expo/api-types";

/** Full-screen POS route of the public application. */
export const CASH_REGISTER_ROUTE = "/caisse";

export const isCashRegisterHolder = (userRole?: MobileUserRole) =>
  userRole === "cashRegisterHolder";

export const isCashRegisterPath = (pathname: string) =>
  pathname === CASH_REGISTER_ROUTE ||
  pathname.startsWith(`${CASH_REGISTER_ROUTE}/`);

type CashRegisterRedirectInput = {
  isAuthenticated: boolean;
  userRole?: MobileUserRole;
  pathname: string;
};

/** A cash register holder works at a counter, not on the public site: send them back. */
export const shouldRedirectToCashRegister = ({
  isAuthenticated,
  userRole,
  pathname,
}: CashRegisterRedirectInput) =>
  isAuthenticated &&
  isCashRegisterHolder(userRole) &&
  !isCashRegisterPath(pathname);
